<template>
    <div>
        <div v-if="isStateAllowed">
            <div v-for="(c, i) in grouped_components.filter(comp => !comp.omit_in_composition)"
                 class="mb-2"
            >
                <form @submit.prevent="saveAll()"
                      :data-vv-scope="'properties' + i"
                >
                    <b-row>
                        <b-col>
                        <span class="font-weight-bold">
                            <b-badge variant="success"
                                     class="mr-1"
                                     style="width: 90px"
                            >
                                {{ c.cas_number }}
                            </b-badge>
                            {{ c.name }}
                        </span>
                            <span class="font-weight-bold float-right">
                            <b-badge variant="primary"
                                     style="width: 90px"
                            >
                                {{
                                    Math.round(c.final_percentage * 10000) / 10000
                                }}%
                            </b-badge>
                        </span>
                            <hr class="mt-1 mb-2">
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="4">
                            <b-form-checkbox :id="'oxidising_gas_' + i"
                                             :name="'oxidising_gas_' + i"
                                             v-model="c.properties.oxidising_gas"
                                             :value="1"
                                             :unchecked-value="0"
                                             @change="changeCheck(c, 'oxidising_gas')"
                                             class="mt-1"
                            >
                                Gas comburente
                            </b-form-checkbox>
                            <b-form-checkbox :id="'inert_gas_oxidizing_gas_' + i"
                                             :name="'inert_gas_oxidizing_gas_' + i"
                                             v-model="c.properties.inert_gas_oxidizing_gas"
                                             :value="1"
                                             :unchecked-value="0"
                                             @change="changeCheck(c, 'inert_gas_oxidizing_gas')"
                                             class="mt-2"
                            >
                                Gas inerte
                            </b-form-checkbox>
                        </b-col>

                        <b-col md="4"
                               v-if="c.properties.oxidising_gas"
                        >
                            <label :for="'oxygen_equivalence_coefficient_' + i"
                                   class="mb-0"
                            >
                                Coeficientes de equivalencia en oxígeno (Ci)
                            </label>
                            <b-form-input :id="'oxygen_equivalence_coefficient_' + i"
                                          :name="'oxygen_equivalence_coefficient_' + i"
                                          size="sm"
                                          type="number"
                                          v-model="c.properties.oxygen_equivalence_coefficient"
                                          data-vv-as=" "
                                          v-validate="'required|decimal:4|min_value:0|max_value:100000'"
                                          @change="setChanged(c)"
                            />
                            <span class="text-danger small"
                                  v-text="errors.first('properties' + i + '.oxygen_equivalence_coefficient_' + i)"
                            />
                        </b-col>
                        <b-col md="4"
                               v-if="c.properties.inert_gas_oxidizing_gas"
                        >
                            <label :for="'nitrogen_equivalence_coefficient_' + i"
                                   class="mb-0"
                            >
                                Coeficientes de equivalencia en nitrógeno (Kk) (Gases no inflamables, no comburentes)
                            </label>
                            <b-form-input :id="'nitrogen_equivalence_coefficient_' + i"
                                          :name="'nitrogen_equivalence_coefficient_' + i"
                                          size="sm"
                                          type="number"
                                          v-model="c.properties.nitrogen_equivalence_coefficient"
                                          data-vv-as=" "
                                          v-validate="'required|decimal:4|min_value:0|max_value:100000'"
                                          @change="setChanged(c)"
                            />
                            <span class="text-danger small"
                                  v-text="errors.first('properties' + i + '.nitrogen_equivalence_coefficient_' + i)"
                            />
                        </b-col>

                        <b-col md="1">
                        </b-col>
                    </b-row>
                </form>
            </div>

            <div class="p-2 mb-2">
                <b-row>
                    <b-col class="mb-0">
                        <div class="metric-card p-3">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <div class="metric-icon bg-soft-success">
                                    <i class="fa fa-cloud icon-success"></i>
                                </div>
                                <div class="status-badge text-uppercase">Total: {{
                                        Math.round(result() * 10000) / 10000
                                    }}
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <b-row>
                <b-col cols="12"
                       class="text-center mb-2 mt-1"
                >
                    <b-btn variant="success"
                           :disabled="!grouped_components.some(c => c.changed)"
                           size="sm"
                           @click="saveAll()"
                    >
                        <i class="fa fa-save"/>
                        <span v-if="grouped_components.some(c => c.changed)">
                        Guardar <b-badge variant="light"> {{
                                grouped_components.filter(comp => comp.changed).length
                            }}</b-badge> componente(s)
                    </span>
                        <span v-else>
                        Guardar componentes
                    </span>
                    </b-btn>
                </b-col>
            </b-row>
        </div>

        <classification :classification.sync="classification"/>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState, mapGetters} from 'vuex';
import Classification from '../../../components/classification.vue';

export default {
    name: 'index',
    components: {
        Classification,
    },
    data() {
        return {
            name: '',
            typing_timer: null,
            done_typing_interval: 500,
            saving: false,
        };
    },
    computed: {
        ...mapState('calculator', [
            'product',
            'raw_material',
            'only_view',
            'grouped_components',
            'classification'
        ]),
        ...mapGetters('calculator', ['isStateAllowed'])
    },
    async mounted() {
        await this._getClassification();
    },
    methods: {
        ...mapActions('calculator', [
            'deleteRawMaterial',
            'updateComponents',
            'getGroupedComponents',
            'getClassification',
            'updatePropertiesComponents',
        ]),
        ...mapMutations('calculator', [
            'setModalRawMaterialShow',
            'setActionRawMaterialShow',
            'setRawMaterial',
            'setModalComponentsShow',
            'setModalToxicityShow',
            'setRawMaterial',
            'setGroupedComponents'
        ]),
        async changeCheck(component, key) {
            if (key === 'oxidising_gas') {
                if (component.properties.oxidising_gas) {
                    component.properties.inert_gas_oxidizing_gas = 0;
                    component.properties.nitrogen_equivalence_coefficient = null;
                } else {
                    component.properties.oxygen_equivalence_coefficient = null;
                }
            } else {
                if (component.properties.inert_gas_oxidizing_gas) {
                    component.properties.oxidising_gas = 0;
                    component.properties.oxygen_equivalence_coefficient = null;
                } else {
                    component.properties.nitrogen_equivalence_coefficient = null;
                }
            }

            this.setChanged(component);
        },
        async saveAll() {
            let valid = await this.validate();

            if (valid) {
                let components = this.grouped_components.filter(c => c.changed);

                await this.updatePropertiesComponents({components});

                await this._getClassification();
            }
        },
        async validate(index = 0) {
            if (index >= this.grouped_components.length) {
                return true;
            }

            let valid = true;
            let second_valid = true;
            let component = this.grouped_components[index];

            if (component.changed) {
                valid = await this.$validator.validateAll('properties' + index);
            }

            second_valid = await this.validate(index + 1);

            return valid && second_valid;
        },
        setChanged(component_product, changed = true) {
            const updatedComponents = this.grouped_components.map(gc =>
                gc.id === component_product.id ? {...gc, changed} : gc
            );
            this.setGroupedComponents(updatedComponents);
        },
        result() {
            let oxidizing_gases_mole_fraction = 0;
            let oxidizing_gases_result = 0;
            let inert_gases_result = 0;

            this.grouped_components.forEach((component) => {
                if (component.properties.oxidising_gas) {
                    oxidizing_gases_result += +component.final_percentage / 100 * component.properties.oxygen_equivalence_coefficient;
                    oxidizing_gases_mole_fraction += +component.final_percentage / 100;
                } else if (component.properties.inert_gas_oxidizing_gas) {
                    inert_gases_result += +component.final_percentage / 100 * component.properties.nitrogen_equivalence_coefficient;
                }
            });

            inert_gases_result += oxidizing_gases_mole_fraction;

            if (inert_gases_result === 0) {
                return 0;
            }

            return oxidizing_gases_result / inert_gases_result * 100;
        },
        async _getClassification() {
            await this.getGroupedComponents();
            await this.getClassification({product_id: this.product.id, danger_code: 'MCAL42'});
        }
    }
};
</script>

<style>
.th-check {
    width: 35px !important;
    max-width: 35px !important;
}
</style>
